var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-btn',{staticClass:"ma-5",on:{"click":_vm.send}},[_vm._v(" Send KillJava ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }